import apiAnimals from "../config/api_animals";
import { logEventInfo } from "../utils/logger";
import getHeaders from "./getHeaders";
// import axios from "axios";

// const apiAnimals = axios.create({
//   // baseURL: process.env.REACT_APP_BOVEXO_ANIMALS_URL,
//   baseURL: "http://localhost:8084",
// });

export function getAllCattleProducers(payload) {
  const { groupId, farmId, page, sorter, filters, size, signal } = payload;
  const handleOrder = (order) => (order === "descend" ? "DESC" : "ASC");
  logEventInfo("getAllCattleProducers", payload);
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/cattle-producers?${
      page ? `&page=${page - 1}` : ""
    }${size ? `&size=${size}` : ""}${
      filters && filters !== "" ? `&search=${encodeURIComponent(filters)}` : ""
    }${
      sorter && Object.entries(sorter).length > 0
        ? `&sort=${sorter.field}&direction=${handleOrder(sorter.order)}`
        : ""
    }`,
    getHeaders(false, signal)
  );
}

export function getCattleProducerShow(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/cattle-producers/${id}`,
    getHeaders(false, signal)
  );
}

export function saveCattleProducer(payload) {
  const { groupId, farmId, id, cattleProducer } = payload;
  if (id != null) {
    return apiAnimals.patch(
      `/bovexo/${groupId}/farms/${farmId}/cattle-producers/${id}`,
      cattleProducer,
      getHeaders(false, null)
    );
  } else {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/cattle-producers`,
      cattleProducer,
      getHeaders(false, null)
    );
  }
}

export function deleteCattleProducer(payload) {
  const { groupId, farmId, id, signal = null } = payload;
  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/cattle-producers/${id}`,
    getHeaders(false, signal)
  );
}

export function getCattleProducersDropdown(payload) {
  const { groupId, farmId, signal } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/cattle-producers?withoutPagination=true`,
    getHeaders(false, signal)
  );
}
